import { render, staticRenderFns } from "./schoolGoods.vue?vue&type=template&id=25ecfd48"
import script from "./schoolGoods.vue?vue&type=script&lang=js"
export * from "./schoolGoods.vue?vue&type=script&lang=js"
import style0 from "./schoolGoods.vue?vue&type=style&index=0&id=25ecfd48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports